/*************************************************/
/* STICKY SIDEBAR                                */
/*************************************************/

import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';

export function stickySidebar() {
    const breakpointMaxM = 768;

    var init = function () {

        const sidebar = document.getElementById('siteGridLayoutLeft');
        if ($(sidebar).length > 0) {

            var stickyResizeTimer;
            var stickySidebar = null;

            //This is to measure if the sticky sidebar should actually be initialised. 
            //If the sidebar i as height or higher than the content, it should not, because that can cause layout trouble.
            $(window).on("resize", function () {
                const width = $("body").width();
                if (width > breakpointMaxM) {
                    stickyResizeTimer = setTimeout(function () {
                        var sidebarHeight = $(".menu-subnav__wrap").outerHeight();
                        var contentHeight = $(".site-grid-layout__right").outerHeight();
                        if (contentHeight > sidebarHeight) {
                            stickySidebar = initStickySidebar(sidebar);
                        } else {
                            if (stickySidebar != null) {

                                stickySidebar.destroy();
                                stickySidebar = null;
                            }
                        }
                    }, 500);
                }
            });

            //Creating and dispatching a couple of resize event, to make sure the initialization code is run on page load
            var intervalCounter = 0;
            var resizeInterval = setInterval(function () {
                const width = $("body").width();
                if (width > breakpointMaxM) {
                    if (intervalCounter == 5) {
                        window.clearInterval(resizeInterval);
                    }

                    var event;
                    if (typeof (Event) === 'function') {
                        event = new Event('resize');
                    } else {
                        event = document.createEvent('Event');
                        event.initEvent('resize', true, true);
                    }
                    window.dispatchEvent(event);
                    intervalCounter++;
                }
            },
                1000);
        }
    };

    var initStickySidebar = function (sidebar) {
        return new StickySidebar(sidebar,
            {
                containerSelector: ".site-grid-layout",
                innerWrapperSelector: ".menu-subnav__wrap",
                topSpacing: 135,
                bottomSpacing: 100,
                resizeSensor: false
            });
    }

    init();
}